import Modal from 'components/modal';
import React, { ReactElement, useEffect, useState } from 'react';

const PriceAlertEmailModal: React.FC = (): ReactElement | null => {
    const [alertType, setAlertType] = useState('');
    const [price, setPrice] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');

    const PriceAlertModalFailed = React.lazy(() => import('./components/price-alert-modal-failed/price-alert-modal-failed'));
    const PriceAlertModalSucceed = React.lazy(() => import('./components/price-alert-modal-succeed/price-alert-modal-succeed'));
    const PriceAlertModalRemoved = React.lazy(() => import('./components/price-alert-modal-removed/price-alert-modal-removed'));

    const closeModalConfirm = (): void => {
        setAlertType('');
    };

    useEffect(() => {
        const urlParams = window.location.hash;

        if (urlParams) {
            const urlFragment = urlParams.split('?popup=');

            if (!urlFragment || urlFragment.length <= 1) {
                return;
            }

            const [alertElement, alertPrice] = urlFragment[1].split('&cena=');

            if (alertElement.includes('alert-cenowy-nie-ustawiony')) {
                const errorText = alertElement.split('&blad=')[1];

                if (errorText) {
                    setErrorMessage(decodeURI(errorText));
                }

                setAlertType('error');
            } else if (alertElement.includes('alert-cenowy-potwierdzony')) {
                setPrice(parseFloat(alertPrice));
                setAlertType('success');
            } else if (alertElement.includes('alert-cenowy-usuniety')) {
                setAlertType('removed');
            }

            window.history.pushState({}, document.title, window.location.pathname);
        }
    }, []);

    const projectModal = () => {
        switch (alertType) {
            case 'error': return <PriceAlertModalFailed onClose={closeModalConfirm} errorMessage={errorMessage} />;
            case 'success': return <PriceAlertModalSucceed price={price} onClose={closeModalConfirm} />;
            case 'removed': return <PriceAlertModalRemoved onClose={closeModalConfirm} />;
            default: return '';
        }
    };

    if (alertType !== '') {
        return (
            <Modal
                showCloseIcon={false}
                center={true}
                isOpen={true}
                onClose={closeModalConfirm}
                shouldCloseOnOverlayClick={true}
                modalClassName={`price-alert-modal-${alertType === 'error' ? 'failed' : alertType}`}
            >
                {projectModal()}

            </Modal>
        );
    }

    return null;
};

export default PriceAlertEmailModal;
